import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "flex flex-col gap-y-3" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "text-gray-900 text-lg leading-6 font-medium" }, "Add tags", -1)
const _hoisted_3 = { class: "flex flex-wrap gap-2" }
const _hoisted_4 = { class: "p-4 border border-gray-200 shadow sm:rounded-lg h-52 overflow-auto relative" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { class: "text-gray-500 mb-4" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("hr", { class: "bg-gray-200 w-[445px] -mx-6 mt-5 mb-4" }, null, -1)
const _hoisted_8 = { class: "flex flex-col gap-y-3" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", { class: "text-gray-900 text-lg leading-6 font-medium" }, "Remove tags", -1)
const _hoisted_10 = { class: "flex flex-wrap gap-2" }
const _hoisted_11 = { class: "p-4 border border-gray-200 shadow sm:rounded-lg h-52 overflow-auto relative" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { class: "text-gray-500 mb-4" }

import { onMounted, ref, watch } from "vue"
import { SearchIcon } from "@heroicons/vue/outline"
import GgmsLoading from "@/components/GgmsLoading.vue"
import GgmsCheckBox from "@/components/GgmsCheckBox.vue"
import GgmsChip from "@/components/GgmsChip.vue"
import GgmsInput from "@/components/GgmsInput.vue"
import { debounce, getNotFoundText } from "@/shared/utils/helpers"
import { useWorkflowStore } from "@/stores/workflow"
import { useTagStore } from "@/stores/tag"
import { Tag } from "@/shared/models/tag"


export default /*#__PURE__*/_defineComponent({
  __name: 'ApplyTagsComponent',
  setup(__props) {

const tagStore = useTagStore()
const workflowStore = useWorkflowStore()

const toAddSearch = ref("")
const toRemoveSearch = ref("")

const toAddTags = ref<Tag[] | undefined>([])
const toRemoveTags = ref<Tag[] | undefined>([])

function getTagClass(tag: Tag) {
    return !tag.isHidden ? "mb-4 last:mb-0" : ""
}

function removeTagFromList(tag: Tag, list: "added" | "removed") {
    if (list === "added") {
        const index = toAddTags.value?.findIndex((t) => t._id === tag._id)
        if (index !== undefined && index !== -1) {
            workflowStore.toAdd[index] = false
        }
    } else {
        const index = toRemoveTags.value?.findIndex((t) => t._id === tag._id)
        if (index !== undefined && index !== -1) {
            workflowStore.toRemove[index] = false
        }
    }
}

onMounted(async () => {
    await tagStore.getTags()
    toAddTags.value = await tagStore.getAllTagsBySearch(toAddSearch.value)
    toRemoveTags.value = await tagStore.getAllTagsBySearch(toRemoveSearch.value)
})

watch(
    () => [workflowStore.toAdd, workflowStore.toRemove],
    () => {
        workflowStore.areButtonDisabled =
            !workflowStore.toAdd.filter((data) => data).length && !workflowStore.toRemove.filter((data) => data).length
    },
    { deep: true }
)

watch(
    () => toAddSearch.value,
    debounce(async () => {
        toAddTags.value = await tagStore.getAllTagsBySearch(toAddSearch.value)
    }, 250)
)

watch(
    () => toRemoveSearch.value,
    debounce(async () => {
        toRemoveTags.value = await tagStore.getAllTagsBySearch(toRemoveSearch.value)
    }, 250)
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(toAddTags.value?.filter((tag, i) => _unref(workflowStore).toAdd[i]), (tag) => {
          return (_openBlock(), _createBlock(GgmsChip, {
            class: "h-6 mx-1",
            key: tag._id,
            bgColor: tag.backgroundColor,
            textColor: tag.foregroundColor,
            onOnRemove: ($event: any) => (removeTagFromList(tag, 'added'))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(tag.displayName), 1)
            ]),
            _: 2
          }, 1032, ["bgColor", "textColor", "onOnRemove"]))
        }), 128))
      ]),
      _createVNode(GgmsInput, {
        modelValue: toAddSearch.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((toAddSearch).value = $event)),
        placeholder: "Search values",
        iconStart: _unref(SearchIcon)
      }, null, 8, ["modelValue", "iconStart"]),
      _createElementVNode("div", _hoisted_4, [
        (_unref(tagStore).tableState.isLoading)
          ? (_openBlock(), _createBlock(GgmsLoading, { key: 0 }))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(toAddTags.value, (tag, i) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: tag._id,
                  class: _normalizeClass(["flex items-center", getTagClass(tag)])
                }, [
                  (!tag.isHidden)
                    ? (_openBlock(), _createBlock(GgmsCheckBox, {
                        key: 0,
                        modelValue: _unref(workflowStore).toAdd[i],
                        "onUpdate:modelValue": ($event: any) => ((_unref(workflowStore).toAdd[i]) = $event),
                        classes: ['mr-3']
                      }, {
                        default: _withCtx(() => [
                          _createVNode(GgmsChip, {
                            bgColor: tag.backgroundColor,
                            textColor: tag.foregroundColor,
                            isRemovable: false
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(tag.displayName), 1)
                            ]),
                            _: 2
                          }, 1032, ["bgColor", "textColor"])
                        ]),
                        _: 2
                      }, 1032, ["modelValue", "onUpdate:modelValue"]))
                    : _createCommentVNode("", true)
                ], 2))
              }), 128)),
              (!toAddTags.value?.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _createElementVNode("p", _hoisted_6, _toDisplayString(_unref(getNotFoundText)("tags", _unref(tagStore).tableState.search)), 1)
                  ]))
                : _createCommentVNode("", true)
            ], 64))
      ])
    ]),
    _hoisted_7,
    _createElementVNode("div", _hoisted_8, [
      _hoisted_9,
      _createElementVNode("div", _hoisted_10, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(toRemoveTags.value?.filter((tag, i) => _unref(workflowStore).toRemove[i]), (tag) => {
          return (_openBlock(), _createBlock(GgmsChip, {
            class: "h-6 mx-1",
            key: tag._id,
            bgColor: tag.backgroundColor,
            textColor: tag.foregroundColor,
            onOnRemove: ($event: any) => (removeTagFromList(tag, 'removed'))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(tag.displayName), 1)
            ]),
            _: 2
          }, 1032, ["bgColor", "textColor", "onOnRemove"]))
        }), 128))
      ]),
      _createVNode(GgmsInput, {
        modelValue: toRemoveSearch.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((toRemoveSearch).value = $event)),
        placeholder: "Search values",
        iconStart: _unref(SearchIcon)
      }, null, 8, ["modelValue", "iconStart"]),
      _createElementVNode("div", _hoisted_11, [
        (_unref(tagStore).tableState.isLoading)
          ? (_openBlock(), _createBlock(GgmsLoading, { key: 0 }))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(toRemoveTags.value, (tag, i) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: tag._id,
                  class: _normalizeClass(["flex items-center", getTagClass(tag)])
                }, [
                  (!tag.isHidden)
                    ? (_openBlock(), _createBlock(GgmsCheckBox, {
                        key: 0,
                        modelValue: _unref(workflowStore).toRemove[i],
                        "onUpdate:modelValue": ($event: any) => ((_unref(workflowStore).toRemove[i]) = $event),
                        classes: ['mr-3']
                      }, {
                        default: _withCtx(() => [
                          _createVNode(GgmsChip, {
                            bgColor: tag.backgroundColor,
                            textColor: tag.foregroundColor,
                            isRemovable: false
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(tag.displayName), 1)
                            ]),
                            _: 2
                          }, 1032, ["bgColor", "textColor"])
                        ]),
                        _: 2
                      }, 1032, ["modelValue", "onUpdate:modelValue"]))
                    : _createCommentVNode("", true)
                ], 2))
              }), 128)),
              (!toRemoveTags.value?.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                    _createElementVNode("p", _hoisted_13, _toDisplayString(_unref(getNotFoundText)("tags", _unref(tagStore).tableState.search)), 1)
                  ]))
                : _createCommentVNode("", true)
            ], 64))
      ])
    ])
  ], 64))
}
}

})